import { StatusChip } from "components/StatusChip";

import { daysUntil, deadlineSeverity } from "./shipmentDisplay";

/**
 * How long a container has left, as a chip.
 *
 * Shared by the packaging wizard and the add-containers dialog: both are the
 * same decision — which drums go on this shipment — and the deadline is the
 * main thing that decides it, so they must not disagree about how it looks or
 * when it is urgent.
 */
export function DeadlineChip({ deadline }: { deadline: string | null | undefined }) {
  const days = daysUntil(deadline);
  if (days === null) {
    return null;
  }
  const label = days < 0 ? `${-days}d overdue` : `${days}d`;
  return <StatusChip label={label} color={deadlineSeverity(days)} variant="soft" />;
}
